// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3WudB","productName":"Table_productName__34ugR"};